export const MATCH_PROVENANCE_TEXT_KEY = {
  applicant: 'RentalPortal.MatchProvenanceApplicantKey',
  confirmed: 'RentalPortal.MatchProvenanceConfirmedKey',
  greta_message: 'RentalPortal.MatchProvenanceGretaKey',
  manual: 'RentalPortal.MatchProvenanceManualKey',
}

export const MATCH_PROVENANCE_DOT_CLASS = {
  applicant: 'applicant',
  confirmed: 'confirmed',
  greta_message: 'suggested',
  manual: 'manual',
}
